export const HISTORY_STORAGE_KEY = 'mediocre_obra_history';
const MAX_ITEMS = 50;

export interface HistoryEntry {
    id: number;
    nome?: string;
    imagem?: string;
    visitedAt: number;
    recentChapters?: Array<{
        id: number;
        numero?: number | string;
        nome?: string;
        visitedAt: number;
    }>;
}

function loadRaw(): HistoryEntry[] {
    if (typeof window === 'undefined') return [];
    try {
        const raw = localStorage.getItem(HISTORY_STORAGE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw) as unknown;
        if (!Array.isArray(parsed)) return [];
        return parsed.filter(
            (e): e is HistoryEntry =>
                e != null && typeof e === 'object' && typeof (e as HistoryEntry).id === 'number',
        );
    } catch {
        return [];
    }
}

function save(items: HistoryEntry[]) {
    if (typeof window === 'undefined') return;
    try {
        localStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
    } catch {
        // ignore
    }
}

/** Adiciona uma obra ao histórico (ou move para o topo se já existir). */
export function addObraToHistory(obra: { id: number; nome?: string; imagem?: string }) {
    const list = loadRaw();
    const now = Date.now();
    const prev = list.find((e) => e.id === obra.id);
    const entry: HistoryEntry = {
        id: obra.id,
        nome: obra.nome,
        imagem: obra.imagem,
        visitedAt: now,
        recentChapters: prev?.recentChapters,
    };
    const filtered = list.filter((e) => e.id !== obra.id);
    save([entry, ...filtered]);
}

/** Registra a obra no histórico e anexa o capítulo lido (mantém os 3 últimos, sem duplicar o mesmo id). */
export function addObraChapterToHistory(
    obra: { id: number; nome?: string; imagem?: string },
    chapter: { id: number; numero?: number | string; nome?: string },
) {
    const list = loadRaw();
    const now = Date.now();
    const prev = list.find((e) => e.id === obra.id);
    const prevChapters = Array.isArray(prev?.recentChapters) ? prev!.recentChapters : [];
    const chapterEntry = {
        id: chapter.id,
        numero: chapter.numero,
        nome: chapter.nome,
        visitedAt: now,
    };
    const recentChapters = [chapterEntry, ...prevChapters.filter((c) => c.id !== chapter.id)].slice(0, 3);
    const entry: HistoryEntry = {
        id: obra.id,
        nome: obra.nome,
        imagem: obra.imagem,
        visitedAt: now,
        recentChapters,
    };
    const filtered = list.filter((e) => e.id !== obra.id);
    save([entry, ...filtered]);
}

/** Últimas obras visitadas (mais recente primeiro). */
export function getHistory(): HistoryEntry[] {
    return loadRaw();
}

export function clearHistory(): void {
    if (typeof window === 'undefined') return;
    try {
        localStorage.removeItem(HISTORY_STORAGE_KEY);
    } catch {
        // ignore
    }
}
